import UserApi from '@api/UserApi'
import * as actionTypes from './actionTypes'
import * as mutationTypes from './mutationTypes'

export default {
  [ actionTypes.GET_RECENTLY_ADDED_USERS ] (context, state) {
    context.commit(mutationTypes.SET_RECENTLY_ADDED_USERS_LOADING, true)
    new UserApi({
      simulateExample: 'Recently Added User List'
    })
      .recentHistory({
        action: 'Added'
      })
      .then(response => {
        context.commit(mutationTypes.SET_RECENTLY_ADDED_USERS, response)
      })
      .catch(_ => {
        context.commit(mutationTypes.SET_RECENTLY_ADDED_USERS_LOADING, false)
      })
  },

  [ actionTypes.GET_RECENTLY_UPDATED_USERS ] (context, state) {
    context.commit(mutationTypes.SET_RECENTLY_UPDATED_USERS_LOADING, true)
    new UserApi({
      simulateExample: 'Recently Update User List'
    })
      .recentHistory({
        action: 'Updated'
      })
      .then(response => {
        context.commit(mutationTypes.SET_RECENTLY_UPDATED_USERS, response)
      })
      .catch(_ => {
        context.commit(mutationTypes.SET_RECENTLY_UPDATED_USERS_LOADING, false)
      })
  },

  [ actionTypes.GET_PENDING_USERS ] (context, state) {
    context.commit(mutationTypes.SET_PENDING_USERS_LOADING, true)
    new UserApi({
      simulateExample: 'Pending Registration List'
    })
      .recentHistory({
        action: 'pendingRegistration'
      })
      .then(response => {
        context.commit(mutationTypes.SET_PENDING_USERS, response)
      })
      .catch(_ => {
        context.commit(mutationTypes.SET_PENDING_USERS_LOADING, false)
      })
  }
}
